import type { ColumnDef } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';
import { StarNameCell } from '../../../FileCells/StarNameCell';
import { SortIcons } from '../FileListTable/SortIcons';

export const NameColumn: ColumnDef<File> = {
  id: 'nom',
  accessorFn: (row) => row.nom,
  header: ({ column }) => (
    <button
      onClick={() => column.toggleSorting()}
      className="flex items-center gap-1 pl-3"
    >
      Nom
      <SortIcons sortDirection={column.getIsSorted()} />
    </button>
  ),
  cell: (props) => (
    <StarNameCell
      id={props.row.original.id}
      nom={String(props.getValue())}
      lu={props.row.original.lu}
      favori={props.row.original.favori}
    />
  ),
  enableSorting: true,
  size: 250,
};
